import * as React from 'react'
import SVG from 'react-inlinesvg'

interface Props {
  name: IconName
  color?: string
  size?: number
  height?: number
}

const icons: { [key in IconName]: string } = {
  activity: require('./svg/activity.svg').default,
  alert: require('./svg/alert.svg').default,
  arrowUp: require('./svg/arrow_up.svg').default,
  back: require('./svg/back.svg').default,
  bluetooth: require('./svg/bluetooth.svg').default,
  card: require('./svg/card.svg').default,
  chevronDown: require('./svg/chevronDown.svg').default,
  chevronRight: require('./svg/chevronRight.svg').default,
  chevronLeft: require('./svg/chevronLeft.svg').default,
  clock: require('./svg/clock.svg').default,
  close: require('./svg/close.svg').default,
  domotic: require('./svg/domotic.svg').default,
  heart: require('./svg/heart.svg').default,
  home: require('./svg/home.svg').default,
  infos: require('./svg/infos.svg').default,
  invert: require('./svg/invert.svg').default,
  lock: require('./svg/lock.svg').default,
  logo: require('./svg/logo.svg').default,
  map: require('./svg/map.svg').default,
  menu: require('./svg/menu.svg').default,
  minus: require('./svg/minus.svg').default,
  next: require('./svg/next.svg').default,
  pen: require('./svg/pen.svg').default,
  plus: require('./svg/plus.svg').default,
  power: require('./svg/power.svg').default,
  redirect: require('./svg/redirect.svg').default,
  restaurant: require('./svg/restaurant.svg').default,
  room: require('./svg/room.svg').default,
  settings: require('./svg/settings.svg').default,
  share: require('./svg/share.svg').default,
  sliders: require('./svg/sliders.svg').default,
  up: require('./svg/up.svg').default,
  user: require('./svg/user.svg').default,
  checkFill: require('./svg/checkFill.svg').default,
  checkEmpty: require('./svg/checkEmpty.svg').default,
  gps: require('./svg/gps.svg').default,
  lightbulbOn: require('./svg/lightbulb_on.svg').default,
  lightbulbOff: require('./svg/lightbulb_off.svg').default,
  wind: require('./svg/wind.svg').default,
  pin: require('./svg/pin.svg').default,
  addAgenda: require('./svg/add_agenda.svg').default,
  phone: require('./svg/phone.svg').default,
  wellBeing: require('./svg/well_being.svg').default,
  location: require('./svg/location.svg').default,
  blockchain: require('./svg/blockchain.svg').default,
  coins: require('./svg/coins.svg').default,
  'box-n-services': require('./svg/box-n-services.svg').default,
}

export default ({ name, size, color, height }: Props) => {
  const iconSrc = icons[name || 'alert']

  return (
    <div style={{ height: size, width: size, color }}>
      <SVG
        src={iconSrc}
        preProcessor={code =>
          code
            .replace(/ width=".*?"/g, ` width="${size}"`)
            .replace(/height=".*?"/g, `height="${height ? height : size}"`)
        }
      />
    </div>
  )
}
